module.exports = __webpack_public_path__ + "img/znyy.4163c83f.png";